import React from 'react'
import Input from 'components/Input'
import PhoneNumberInput from 'components/PhoneNumberInput'
import { withTranslation } from 'react-i18next'

const StepTwoForm = ({ t }) => {

  const fields = [
    [
      {
        name: 'first_name',
        label: t('registration.field.fname')
      },
      {
        name: 'last_name',
        label: t('registration.field.lname')
      }
    ],
    {
      name: 'email',
      label: t('registration.field.email')
    },
    {
      name: 'phone',
      label: t('registration.field.phone')
    }
  ]

  return (
    <div className="grid grid-cols-2 gap-5">
      {
        fields.map((field, index) => {
          return (
            <React.Fragment key={`${index}_`}>
              {
                field?.length ? (
                  <>
                    {
                      field.map(singleField => {
                        return (
                          <Input
                            name={singleField.name}
                            label={singleField.label}
                            placeholder={singleField.placeholder}
                            key={singleField.name}
                            labelwithin={true}
                          />
                        )
                      })
                    }
                  </>
                ) : (
                  <div className="col-span-2">
                    {
                      field.name === 'phone' ? (
                        <PhoneNumberInput 
                          name={field.name}
                          label={field.label}
                          className="w-full border p-4 rounded-lg bg-default"
                        />
                      ) : (
                        <Input 
                          name={field.name}
                          label={field.label}
                          placeholder={field.placeholder}
                          labelwithin={true}
                        />
                      )
                    }
                  </div>
                )
              }
            </React.Fragment>
          )
        })
      }
    </div>
  )
}



export default withTranslation()(StepTwoForm)